import {withIntegrity} from '../hocs/integrity/withIntegrity';
import Grid from './grid-dx/MasterGrid';

export default withIntegrity(Grid);
